import { Box, Typography } from '@mui/material'
import WavesImg from 'assets/icons/Waves.svg'
import { SvgImage, Text } from 'components'
import { Center, Container } from './styles'
const SystemUnderMaintenance: React.FC = () => {
  return (
    <Container>
      <Center>
        <SvgImage name="NoDataIcon" width={100} height={100} />
        <Text fontSize="24px" fontWeight="600" color="#000000">
          System Under Maintenance
        </Text>
        <Box width="50%">
          <Text fontSize="18x" color="#4D515F" align="center">
            The My MVU Smart Portal is currently down for maintenance. We expect
            to be back in working the next business day. Thank you for your
            patience.
          </Text>
        </Box>
        <Box display="flex" flexDirection="column" gap="5px">
          <Typography
            align="center"
            textTransform="uppercase"
            color="#4d515f"
            fontSize="12px"
          >
            Reach us at
          </Typography>
          <Box display="flex" gap="5px" alignSelf="center">
            <Text color="#000000" fontWeight="600" fontSize="16px">
              Customer Service:
            </Text>
            <Typography color="#1513C3">844-425-0855</Typography>
          </Box>
        </Box>
      </Center>
      <Box component="img" src={WavesImg} alt="background" />
    </Container>
  )
}

export default SystemUnderMaintenance
